import { trigger, transition, style, animate } from '@angular/animations';

export const fadeInAnimation = trigger('routeAnimations', [
  transition('* <=> *', [
    style({ opacity: 0 }),
    animate('175ms ease-in', style({ opacity: 1 }))
  ])
]);